var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/feed-suggestions/feed-suggestions.tsx";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.map.js";
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import VerificationBadge from 'soapbox/components/verification_badge';
import { useAccount, useAppSelector } from 'soapbox/hooks';
import { Card, CardBody, CardTitle, HStack, Stack, Text } from '../../components/ui';
import ActionButton from '../ui/components/action-button';
const messages = defineMessages({
  heading: {
    "id": "feed_suggestions.heading",
    "defaultMessage": "Suggested profiles"
  },
  viewAll: {
    "id": "feed_suggestions.view_all",
    "defaultMessage": "View all"
  }
});
const SuggestionItem = ({
  accountId
}) => {
  const account = useAccount(accountId);
  return /*#__PURE__*/React.createElement(Stack, {
    space: 3,
    className: "p-4 md:p-0 rounded-md border border-solid border-gray-100 dark:border-slate-700 dark:md:border-transparent md:border-transparent w-52 shrink-0 md:shrink md:w-full",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Link, {
    to: `/@${account.acct}`,
    title: account.acct,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    space: 3,
    className: "w-40 md:w-24 mx-auto",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: account.avatar,
    className: "mx-auto block w-16 h-16 min-w-[56px] rounded-full object-cover",
    alt: account.acct,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement(Stack, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(HStack, {
    alignItems: "center",
    justifyContent: "center",
    space: 1,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "semibold",
    dangerouslySetInnerHTML: {
      __html: account.display_name
    },
    truncate: true,
    align: "center",
    size: "sm",
    className: "max-w-[95%]",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 15
    }
  }), account.verified && /*#__PURE__*/React.createElement(VerificationBadge, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 36
    }
  })), /*#__PURE__*/React.createElement(Text, {
    theme: "muted",
    align: "center",
    size: "sm",
    truncate: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48,
      columnNumber: 13
    }
  }, "@", account.acct)))), /*#__PURE__*/React.createElement("div", {
    className: "text-center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(ActionButton, {
    account: account,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 54,
      columnNumber: 9
    }
  })));
};
const FeedSuggestions = () => {
  const intl = useIntl();
  const suggestedProfiles = useAppSelector(state => state.suggestions.items);
  const isLoading = useAppSelector(state => state.suggestions.isLoading);
  if (!isLoading && suggestedProfiles.size === 0) return null;
  return /*#__PURE__*/React.createElement(Card, {
    size: "lg",
    variant: "rounded",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(HStack, {
    justifyContent: "between",
    alignItems: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 69,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(CardTitle, {
    title: intl.formatMessage(messages.heading),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 70,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(Link, {
    to: "/suggestions",
    className: "text-primary-600 dark:text-primary-400 hover:underline",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 72,
      columnNumber: 9
    }
  }, intl.formatMessage(messages.viewAll))), /*#__PURE__*/React.createElement(CardBody, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 80,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(HStack, {
    alignItems: "center",
    className: "overflow-x-auto lg:overflow-x-hidden space-x-4 md:space-x-0",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 81,
      columnNumber: 9
    }
  }, suggestedProfiles.slice(0, 4).map(suggestedProfile => /*#__PURE__*/React.createElement(SuggestionItem, {
    key: suggestedProfile.account,
    accountId: suggestedProfile.account,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 83,
      columnNumber: 13
    }
  })))));
};
export default FeedSuggestions;